import {
  createMigrationIds,
  createMigrationSequence,
  createTLStore,
  DocumentRecordType,
  IndexKey,
  pageIdValidator,
  PageRecordType,
  PointerRecordType,
  TLDOCUMENT_ID,
  TLPOINTER_ID,
  TLRecord,
  TLStoreSnapshot,
} from "tldraw"
import { Layer } from "./Layer"
import { LDPageMeta } from "./LDPage"

const liveDrawPageVersions = createMigrationIds("io.livedraw.page", {
  LiveDrawMeta: 1,
})

const pageMigration = createMigrationSequence({
  sequenceId: "io.livedraw.page",
  retroactive: true,
  sequence: [
    {
      id: liveDrawPageVersions.LiveDrawMeta,
      scope: "record",
      filter: (record) => {
        console.log("RECORD", record)
        return record.typeName === "page"
      },
      dependsOn: ["com.tldraw.page/1"],
      up: (record: any) => {
        console.log("UP MIGRATION", record.id)
        record.meta = {
          currentLayer: Layer.layer1.id,
          layers: {
            layer1: Layer.layer1,
          },
          previewUrl: null,
          parameters: {},
          parameterValues: {},
          origin: { x: 0, y: 0 },
          originDisplacement: { x: 0, y: 0 },
        } as LDPageMeta
        return record
      },
    },
  ],
})

export const migrations = [pageMigration]

const initialPageId = pageIdValidator.validate("page:page")

export const initialPageMeta: LDPageMeta = {
  currentLayer: Layer.layer1.id,
  layers: {
    layer1: Layer.layer1,
  },
  previewUrl: null,
  parameters: {},
  parameterValues: {},
  origin: { x: 0, y: 0 },
  originDisplacement: { x: 0, y: 0 },
} as LDPageMeta

export const initialDocMeta = {
  currentPageId: initialPageId,
  recentFillColors: [],
  recentStrokeColors: [],
}

export const initialStore = createTLStore({
  migrations,
})
initialStore.put([
  DocumentRecordType.create({
    id: TLDOCUMENT_ID,
    name: initialStore.props.defaultName,
    // the current page is tracked on TLSessionStateSnapshot
    // but we need to store it with the document
    meta: initialDocMeta,
  }),
  PointerRecordType.create({ id: TLPOINTER_ID }),
  PageRecordType.create({
    id: initialPageId,
    name: "Page 1",
    index: "a1" as IndexKey,
    meta: initialPageMeta,
  }),
])
export const serializedInitialStore: TLStoreSnapshot =
  initialStore.getStoreSnapshot()
